import { useIonRouter } from '@ionic/react';
import { useEffect } from 'react';

import { AUTH_EVENTS, authEvents } from '../../utils/authEvents';

/**
 * Hook que escucha eventos de autenticación y maneja la navegación.
 * Debe usarse en un componente que tenga acceso al IonRouter.
 */
export const useAuthNavigator = () => {
  const router = useIonRouter();

  useEffect(() => {
    const unsubscribe = authEvents.on(AUTH_EVENTS.SESSION_EXPIRED, () => {
      // Evitar navegar si ya estamos en /auth
      if (window.location.pathname !== '/auth') {
        router.push('/auth', 'root', 'replace');
      }
    });

    return () => {
      unsubscribe();
    };
  }, [router]);
};
